import { render, staticRenderFns } from "./ParentMenuRoute.vue?vue&type=template&id=8df22184&scoped=true&"
import script from "./ParentMenuRoute.vue?vue&type=script&lang=js&"
export * from "./ParentMenuRoute.vue?vue&type=script&lang=js&"
import style0 from "./ParentMenuRoute.vue?vue&type=style&index=0&id=8df22184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df22184",
  null
  
)

export default component.exports